// @flow

import * as React from 'react';
import { Input } from 'antd';

import type { UpdateEstimateItemFieldParams } from '../../../types';

const { TextArea } = Input;

type Props = {
  editable: boolean,
  estimateGroupIndex: number,
  estimateItemIndex: number,
  note: null|string,
  onChangeEstimateItemField: (params: UpdateEstimateItemFieldParams) => void,
}

export default class extends React.PureComponent<Props> {

  onChangeEstimateItemField = async (field: string, value: string) => {

    const {
      estimateGroupIndex,
      estimateItemIndex,
      onChangeEstimateItemField
    } = this.props;

    await onChangeEstimateItemField({
      estimateGroupIndex,
      estimateItemIndex,
      field,
      value
    });

  }

  render () {

    const {
      editable,
      note
    } = this.props;

    return (

      <div style={{ minWidth: 320, maxWidth: 320 }}>

        {editable && (
          <TextArea
            value={note}
            onChange={(event) => this.onChangeEstimateItemField('notes', event.target.value)}
          />
        )}
        
        {!editable && (
          <div>
            {note}
          </div>
        )}

      </div>
      
    )
  }
}